<template>
  <div class="about">
    <AboutHeader />
    <AboutTech />
    <AboutService />
    <AboutTrusted />
    <AboutCallAction />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import AboutHeader from "@/components/about/AboutHeader.vue";
import AboutTech from "@/components/about/AboutTech.vue";
import AboutService from "@/components/about/AboutService.vue";
import AboutTrusted from "@/components/about/AboutTrusted";
import AboutCallAction from "@/components/about/AboutCallAction.vue";
export default {
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  components: {
    AboutHeader,
    AboutTech,
    AboutService,
    AboutTrusted,
    AboutCallAction,
  },
  setup() {
    useMeta({
      title:
        "À propos de Livratos – La plateforme de livraison BTP pensée pour les artisans",
      description: [
        {
          content:
            "Découvrez l’histoire de Livratos, la plateforme de livraison dédiée au BTP qui simplifie le lien entre fournisseurs, artisans et livreurs pour des chantiers plus fluides.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/about",
        },
      ],
    });
  },
};
</script>
